<template>
  <div class="otherQuality">
    <div class="notice">{{notice}}</div>
    <div v-for="(formItemInfo, index) in formInfo" :key="index">
      <!--文本提交-->
      <text-proof
        v-if="formItemInfo.type === '1'"
        :ref="formItemInfo.name"
        :formItemInfo="formItemInfo"
        @onSubmit="getTextInput"
      >
      </text-proof>
      <!--图片上传-->
      <img-proof
        v-else-if="formItemInfo.type === '2'"
        :ref="formItemInfo.name"
        :formItemInfo="formItemInfo"
        @onSubmit="getImgProof"
      >
      </img-proof>
    </div>
    <z-button-group>
      <z-button type="primary" @click="handleSubmit">下一步</z-button>
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Button, ButtonGroup, Dialog } from '@zz-common/zz-ui'
import TextProof from './TextProof'
import ImgProof from './ImgProof'
import { getSubmitConfig, submitAuditInfoNew, checkAuditStatusNew } from '../../../../api/resourceApi'
import { getCookie } from '../../../../lib/utils'

export default {
  name: 'ProductQua',
  data() {
    return {
      notice: '',
      formInfo: [],
      proofList: [],
      quaStatus: '',
      quaProofList: '',
      quaProofId: '',
      permitStatus: ''
    }
  },
  inject: ['$rootEle'],
  methods: {
    async getFormInfo() {
      const res = await getSubmitConfig({ infoId: this.$rootEle.infoId, sourceCode: this.$rootEle.productQuaType })//sourcecode使用quatype的值
      console.log('checkStatusres', res);
      const { notice = '', formInfo = [], status } = res
      this.notice = notice
      this.formInfo = [...formInfo]
      if (status == 1) { // 判断今日是否已达到提交上限
        Dialog.alert({
          message: '您已到达今日提交上限，请明日再提交'
        }).then(() => {
          native.close()
        })
      }
      const { quaStatus, quaProofList, quaProofId, permitStatus } = await checkAuditStatusNew({
        infoId: this.$rootEle.infoId,
        permitType: this.$rootEle.permitType,
        productQuaType: this.$rootEle.productQuaType
      })
      this.quaStatus = quaStatus
      this.quaProofList = quaProofList
      this.quaProofId = quaProofId
      this.permitStatus = permitStatus
      if (quaStatus == '1') {
        this.$rootEle.setResultStatus('over')
        this.$rootEle.stateChange('otherquality', 'result', 3)
      }
      if (['0', '-1'].includes(String(quaStatus))) {
        this.$rootEle.setResultStatus('process')
        this.$rootEle.stateChange('otherquality', 'result', 3)
      }
    },
    async submitFormInfo(params) {
      console.log('submitParms', params)
      await submitAuditInfoNew(params)
      this.$rootEle.stateChange('otherquality', 'result', 3)
    },
    pushToLoacalaProoflist(val) {
      const { name, type, value } = val
      const newValue = type === '2' ? value.join('|') : value
      // 将用户输入的信息,转换为可以提交给后端的信息
      const originValue = this.proofList.filter((item) => item.name === name)[0]
      if (originValue) {
        originValue.value = newValue // 如果用户之前已经选择某个值,则新值进来之后,覆盖老的值
      } else {
        this.proofList.push({
          type,
          value: newValue,
          name
        })
      }
      console.log('this.localFormData: ', this.proofList)
    },
    getTextInput(value) {
      this.pushToLoacalaProoflist(value)
    },
    getImgProof(value) { // 处理图片上传url
      this.pushToLoacalaProoflist(value)
    },
    checkValidity() { // 执行校验逻辑
      let validation = true
      this.formInfo &&
        this.formInfo.forEach((formItemInfo) => {
          const { name, needHide } = formItemInfo
          if (!needHide) {
            // 使用this.$refs[componentRef]时要注意,有些组件虽然在dom中,但是是隐藏的,所以,不能仅仅根据组件是否在dom中判断组件是否可用
            const componentObj = this.$refs[name]
            console.log('componentObj', componentObj);
            if (Array.isArray(componentObj)) {
              // 因为formRefs中的元素,是放置在v-for指令中的,所以,通过$refs引用的对象是个数组
              componentObj.forEach((cmpItem) => {
                if (cmpItem.customValidate) {
                  validation = cmpItem.customValidate() // 触发组件的校验逻辑
                  if (!validation) return true
                }
              })
              if (!validation) return true
            } else {
              if (componentObj.customValidate) {
                validation = componentObj.customValidate()
                if (!validation) return true
              }
            }
          }
        })
      return validation
    },
    handleSubmit() {
      const checkResult = this.checkValidity()
      console.log('handleSubmit', checkResult)
      if (checkResult) { // 通过校验
        console.log('submitParams', this.proofList)
        const proofList = JSON.stringify([...this.proofList])
        const rootSubmitData = Object.entries(this.$rootEle.submitData).reduce((prev, cur) => {
          return { ...prev, ...cur[1] }
        }, {})
        console.log(typeof proofList)
        this.submitFormInfo({
          reqUid: getCookie('uid'),
          proofList,
          infoId: this.$rootEle.infoId,
          sourceCode: this.$rootEle.sourceCode,
          reasonId: this.$rootEle.reasonId - 0,
          quaProofId: this.quaProofId,
          quaType: this.$rootEle.productQuaType,
          permitStatus: this.permitStatus,
          ...rootSubmitData
        })
      }
    }
  },
  components: {
    TextProof,
    ImgProof,
    zButton: Button,
    zButtonGroup: ButtonGroup
  },
  created() {
    this.getFormInfo()
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>
